import { $api } from 'api/axios';
import { HOST_API, HOST_PUBLIC_COMMENTS } from 'config';
import {
  CardsChartResponse,
  ChartRequestParams,
  ClientsChartResponse,
  CommentChartResponse,
  OrderChartResponse,
  PaymentsByTariffChartResponse,
  SalesFunnelChartResponse,
  StatsByProductActualChartResponse,
  StatsByProductChartResponse,
  SubscriptionBaseChartResponse,
  SubscriptionsChartResponse,
  TrialsChartResponse,
} from 'types/charts';

const getOrdersChartData = (params: ChartRequestParams) =>
  $api.get<OrderChartResponse>(HOST_API + `dashboard/orders`, { params });

const getTrialsChartData = (params: ChartRequestParams) =>
  $api.get<TrialsChartResponse>(HOST_API + `dashboard/trials`, { params });

const getCardsChartData = (params: ChartRequestParams) =>
  $api.get<CardsChartResponse>(HOST_API + `dashboard/cards`, { params });

const getClientsChartData = (params: ChartRequestParams) =>
  $api.get<ClientsChartResponse>(HOST_API + `dashboard/clients`, { params });

const getSubscriptionsChartData = (params: ChartRequestParams) =>
  $api.get<SubscriptionsChartResponse>(HOST_API + `dashboard/subscriptions`, { params });

const getSalesFunnelChartData = (params: ChartRequestParams) =>
  $api.get<SalesFunnelChartResponse>(HOST_API + `dashboard/sales-funnel`, { params });

const getStatsByProduct = (params: ChartRequestParams) =>
  $api.get<StatsByProductChartResponse>(HOST_API + `dashboard/stats-by-product`, { params });

const getStatsByProductActual = (params: ChartRequestParams) =>
  $api.get<StatsByProductActualChartResponse>(HOST_API + `dashboard/stats-by-product-actual`);

const getCommentsChartData = (params: ChartRequestParams) =>
  $api.get<CommentChartResponse>(HOST_PUBLIC_COMMENTS + `admin/dashboard/comments`, {
    params,
  });

const getSubscriptionBaseChartData = (params: ChartRequestParams) =>
  $api.get<SubscriptionBaseChartResponse>(HOST_API + `dashboard/subscription-base`, { params });

const getPamentsByTariffChartData = (params: ChartRequestParams) =>
  $api.get<PaymentsByTariffChartResponse>(HOST_API + `dashboard/payments-by-tariff`, { params });

export const ChartsServices = {
  getOrdersChartData,
  getTrialsChartData,
  getCardsChartData,
  getClientsChartData,
  getSubscriptionsChartData,
  getSalesFunnelChartData,
  getStatsByProduct,
  getStatsByProductActual,
  getCommentsChartData,
  getSubscriptionBaseChartData,
  getPamentsByTariffChartData,
};
